import OriginModal from "./Modal";
import confirm from "./confirm";
var Modal = OriginModal;
Modal.confirm = confirm;
export default Modal;